<template>
  <ankh-list :showBtnGroup="false">
    <template #search-form>
      <el-form-item :label="$t('提现编号')">
        <el-input :placeholder="$t('提现编号')" v-model="searchForm.num" clearable/>
      </el-form-item>

      <el-form-item :label="$t('提现者姓名')">
        <el-input :placeholder="$t('提现者姓名')" v-model="searchForm.nickname" clearable/>
      </el-form-item>

      <el-form-item :label="$t('提现平台')">
        <dict-select clearable v-model="searchForm.platform" flag="WITHDRAWAL" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #tab-row>
      <el-radio-group v-model="tabCurrent" class="mb16" @change="$refs.list.handleRequest()">
        <el-radio-button label="toAudit">{{$t('审核中')}}</el-radio-button>
        <el-radio-button label="pass">{{$t('审核通过')}}</el-radio-button>
        <el-radio-button label="noPass">{{$t('审核不通过')}}</el-radio-button>
      </el-radio-group>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :search-params="searchForm"
          :request-params="{status: tabCurrent}"
          :data="tableData"
          @selection-change="selection = $event">
        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" width="50" :label="$t('序号')" fixed />
        <el-table-column prop="num" :label="$t('编号')" fixed/>
        <el-table-column prop="nickname" :label="$t('提现者昵称')" fixed/>
        <el-table-column prop="userNum" :label="$t('提现者编号')" fixed/>
        <el-table-column prop="price" :label="$t('提现金额')">
          <template v-slot="{row}">
            {{row.price | formatPrice}}
          </template>
        </el-table-column>
        <el-table-column prop="platform" :label="$t('提现平台')">
          <template v-slot="{row}">
            <dict-text :status="row.platform" dict-flag="WITHDRAWAL" />
          </template>
        </el-table-column>
        <el-table-column prop="zfbAccount" :label="$t('支付宝账号')"/>
        <el-table-column prop="wxName" :label="$t('微信昵称')"/>
        <el-table-column :label="$t('提现时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('状态')">
          <template v-slot="{row}">
            <dict-text :status="row.status" dict-flag="WITHDRAWAL_STATUS" />
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" width="130" v-if="tabCurrent === 'toAudit'">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleAudit(row)" >{{$t('审核')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template slot="other">
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm">
        <template #title>
          <h4>{{$t('审核')}}</h4>
        </template>

        <el-form label-width="auto" label-position="left" ref="form" :model="formData">
          <el-form-item :label="$t('审核状态')" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio label="pass">{{$t('通过')}}</el-radio>
              <el-radio label="noPass">{{$t('不通过')}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('说明')" prop="auditContent">
            <el-input type="textarea" v-model="formData.auditContent" :rows="5" :placeholder="$t('请输入备注')" />
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button type="primary" @click="handleSubmit">{{$t('确定')}}</el-button>
          <el-button @click="resetForm">{{$t('重置')}}</el-button>
        </template>

      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import DictText from "@/components/dict/DictText";
import DictSelect from "@/components/dict/DictSelect.vue";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "WithdrawalAmountList",
  components: {AnkhList, DictSelect, DictText, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      currentRow: {},
      tabCurrent: "toAudit",
      showDialog: false,
      formData: {
        status: "pass",
        auditContent: ""
      },
    }
  },
  methods: {
    // 提交
    async handleSubmit() {
      try {
        const params = {...this.currentRow, ...this.formData};
        delete params.createTime;
        delete params.updateTime;
        await request(this.$api.withdrawAudit.updateStatus, params, {showLoading: true});
        this.$message.success(this.$t('操作成功'));
        this.showDialog = false;
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    resetForm() {
      this.$refs.form.resetFields();
    },

    handleAudit(row) {
      this.showDialog = true;
      this.currentRow = {...row};
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.withdrawAudit.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
